function DashboardCtrl($scope, $location, $interval, $filter, $state, $timeout, $controller) {

    $scope.type = $state.current.type;
    $scope.entityFilterOptions = {};

    $scope.options = {
        admin: $state.current.admin
    };

    /*
     PID filter
     */
    init();

    $scope.$watch('pid', function(){
       init();
    });

    function init(){

        var monitoringFilter = $scope.tabFilter;
        if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
            if(($scope.type == 'logins' && monitoringFilter.type == 'site') || ($scope.type == 'sites' && monitoringFilter.type != 'site') ){
                return;
            }
            //$scope.monitorItems = {};
            $scope.singlePid = true;
            $scope.pid = monitoringFilter.pid;
            $scope.pidtype = monitoringFilter.type + 's';
            //$scope.entityFilterOptions.updateData = true;
        }

    }
    /*switch ($scope.type) {
        case "sites":
            $scope.facets = [{"id": "type", order:1},{"id": "site_id", "ignoreFilter": true, label: "Client", "hide": true},{"id": "rt_site_id", "label": "Destination"},{"id": "appid", "label": "Destination"},
                {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},{"id": "url_category", "label": "Destination"}];
            break;
        case "logins":
            $scope.facets = [{"id": "type", order:1},{"id": "site_id", "ignoreFilter": true, label: "Client", "hide": true},{"id": "rt_site_id", "label": "Destination"},{"id": "appid", "label": "Destination"},
                {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},{"id": "url_category", "label": "Destination"}];
            break;
        case "apps":
            $scope.facets = [{"id": "type", order:1},{"id": "site_id", label: "Client"},{"id": "appid", "ignoreFilter": true, "hide": true, "label": "appid"},
                {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true}];
            break;
        case "domains":
            break;
        case "categories":
            $scope.facets = [{"id": "type", order:1},{"id": "site_id", label: "Client"}, {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},
                {"id": "url_category", "ignoreFilter": true, "label": "url_category", hide: true}];
            break;
    }*/

}